import { copyApiPrefilterPerRole } from "@shared/backend/entity-security/copy-api-prefilter-per-role";
import { doesExist } from "@shared/backend/entity-security/does-exist";
import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { Allow, remult } from "remult";
import { Opportunity } from "../opportunity";
import { Team } from "../team/entity";
import { type TeamOpportunity } from "./entity";

export const TeamOpportunityEntityConfig: HyperEntityConfig<TeamOpportunity> = {
  allowApiRead: Roles.AdminsAndManager,
  allowApiCrud: Roles.AdminsAndManager,
  apiPrefilterPerRole: async (filter) => {
    filter(Roles.All, {
      opportunity: {
        $is: await copyApiPrefilterPerRole(Opportunity),
      },
    });

    filter(Roles.All, {
      team: {
        $is: await copyApiPrefilterPerRole(Team),
      },
    });
  },

  allowInsertPerRole(allow) {
    allow(Roles.OrganizationManagers, (entity) =>
      doesExist(Team, {
        id: entity.teamId,
        organization: {
          $id: remult.user!.organizationId!,
        },
      }),
    );
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.OrganizationManagers, {
      team: {
        $is: {
          organization: {
            $id: remult.user!.organizationId!,
          },
        },
      },
    });
  },

  id: {
    teamId: true,
    opportunityId: true,
  },
};
